import { useApp } from '../store.js';

/**
 * iOS Safari keyboard/app-shell handling (WebKit has no interactive-widget
 * support): drive the layout height from VisualViewport so nothing hides
 * behind the on-screen keyboard, and flag keyboard-open so the UI can swap
 * fixed toolbars for the in-flow shortcut row.
 */
export function initViewport() {
  const root = document.documentElement;

  const apply = () => {
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    const offsetTop = vv ? vv.offsetTop : 0;
    root.style.setProperty('--app-height', `${Math.round(height)}px`);
    root.style.setProperty('--app-offset-top', `${Math.round(offsetTop)}px`);
    // Heuristic: keyboard is open when the visual viewport lost >120px.
    const keyboardOpen = window.innerHeight - height > 120;
    if (useApp.getState().keyboardOpen !== keyboardOpen) {
      useApp.getState().setKeyboardOpen(keyboardOpen);
      root.classList.toggle('keyboard-open', keyboardOpen);
    }
  };

  apply();
  window.visualViewport?.addEventListener('resize', apply);
  window.visualViewport?.addEventListener('scroll', apply);
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', () => setTimeout(apply, 300));

  // Prevent iOS rubber-band scrolling of the app shell itself.
  document.body.addEventListener(
    'touchmove',
    (e) => {
      if (e.target === document.body) e.preventDefault();
    },
    { passive: false },
  );
}
